const serviceData = [
  {
    id: 1,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641645167/hibernation-hack/13082_w3n709.jpg",
    name: "Yoga",
    location: "",
    link: '/yoga',
  },
  {
    id: 2,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641645160/hibernation-hack/3125988_imnmqc.jpg",
    name: "Blog",
    location: "",
    link: '/blog',
  },
  {
    id: 3,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641645159/hibernation-hack/5473851_xjeppm.jpg",
    name: "21 Days challenge",
    location: "",
    link: '/challenge',
  },
  {
    id: 4,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641645293/hibernation-hack/145411-OTQZ7A-227_iv14ki.jpg",
    name: "Health calculator",
    location: "",
    link: '/calculator',
  },
  
 
];

export default serviceData;
